module.exports = __webpack_public_path__ + "static/media/arrowDown.881a6229.svg";